import React from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'src/viewLayer/helpers/translations'
import { useForgotPasswordPagePath } from 'src/viewLayer/navigation'

import { ForgotPasswordTrackableLink } from './index.styled'

const ForgotPasswordLink = ({ email }) => {
  const navigate = useNavigate()
  const forgotPasswordPath = useForgotPasswordPagePath(email)
  return (
    <ForgotPasswordTrackableLink
      className="ForgotPasswordLink"
      data-testid="forgot-password-link"
      onClick={() => navigate(forgotPasswordPath)}
      size="small"
      trackingId="forgot_password_link"
      weight="strong"
    >
      {t('password.links.forgot_password')}
    </ForgotPasswordTrackableLink>
  )
}

export default ForgotPasswordLink
